<template>
  <div class="nocontent">
    <img src="@/assets/home/nocontent.png" alt="" />
    <template v-if="tag == 'login'">
      <p>您还没登录，快去登录吧</p>
      <el-button type="primary" round @click="handleToLogin">去登录</el-button>
    </template>
    <template v-else>
      <p>暂无内容</p>
    </template>
  </div>
</template>

<script>
import { toLogin } from "@/assets/js/cookie.js";
export default {
  components: {},
  props: { tag: String },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    handleToLogin() {
      toLogin(location.href);
    },
  },
  created() {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">

</style>
